import React, { useState, useEffect, useRef } from 'react';

import { Row, Col, Button, Input, Divider } from 'antd';
import "antd/dist/antd.css";

import "../css/comment.css";
import { tokenizeWords } from './nlp';
import { initialSettings } from './settings'
import PieChart from './pie_chart_3s';
import YoutubeEmbed from './YoutubeEmbed';
import CommentBox from './commentBox_3s';
import WordCloud from './WordCloud';
import LoaderComponent from './loader';


const CommentTemp = () => {

    /////////////////////////////////////////////////////////////
    // useState Hooks for wordcloud
    const [content, setContent] = useState('');
    const [settings, setSettings] = useState(initialSettings);
    const { content: contentSettings, wordcloud: wordcloudSettings } = settings;
    const firstUpdate = useRef(true);

    // calling tokenizeWords function to perform NLP tasks on data recieved
    const words = tokenizeWords(content, contentSettings);
    /////////////////////////////////////////////////////////////


    // useState hooks to store the comments data 
    const [commentData, SetCommentData] = useState({
        data: [],
        message: ''
    });
    const [query, setQuery] = useState('');
    const [search, setSearch] = useState('');

    // useState hooks to manage the display properties of components
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(false);

    // useEffect Hook for action that needs to be taken after the search state is updated
    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        // fetch function for getting comments data
        const GetCommentsData = async () => {
            // GET request using fetch with async/await
            setLoading(true);
            console.log('Search value is : ', search);

            // const response = await fetch('https://c1wmdybhx4.execute-api.ap-south-1.amazonaws.com/default/youtube-comment-sentiment?YouTubeVideoID=' + search);
            const response = await fetch('https://us-central1-youtube-search-test-288907.cloudfunctions.net/youtube-sentiment-function?YouTubeVideoID=' + search);
            if (response.status === 200) {
                const data = await response.json();
                SetCommentData(data);
                /////////////////////////////////////////////////////////////
                // updation of wordcloud state values 
                setContent(data.data);
                /////////////////////////////////////////////////////////////
                if (data.data.length === 0) {
                    setShow(false);
                    setLoading(false);
                }
                else {
                    setShow(true);
                    setLoading(false);
                }
            }
            else {
                setShow(false);
                setLoading(false);
            }
            // console.log('UseEffect show : ', show);
        };
        GetCommentsData();
    }, [search]);


    // Handler function after clicking submit button
    const button_click_handler = async () => {
        // setShow(true);
        try {
            if (query.includes('youtu.be')) {
                setSearch(query.split("youtu.be/")[1].substring(0, 11));
            } else {
                setSearch(query.split("v=")[1].substring(0, 11));
            }
        }
        catch {
            setShow(false);
        }
    }

    // console.log('Outside show : ', show);
    // console.log(commentData);
    // console.log(content);

    // Return Master Layout
    return (
        <React.Fragment>
            <Row>

                {/* Padding */}
                <Col xs={{ span: 2 }} lg={{ span: 4 }}>
                </Col>

                {/* Actual Content */}
                <Col xs={{ span: 20 }} lg={{ span: 16 }}>

                    {/* Welcome Text */}
                    <Row type="flex" justify="center" align="middle">
                        <Col span={18}>
                            <h2 style={{ textAlign: 'center', paddingBottom: 30 }} >Welcome to YouTube Comment Insights</h2>
                            <p>This tool is made to know the <b>quality</b> and <b>community acceptance</b> of the <b>video</b> before investing the <b>time and effort</b> you put into watching it with the help of <b>feature-rich relevant comments data</b> of video</p>
                        </Col>
                        <Divider />
                    </Row>

                    {/* Input Box and Submit Button for API */}
                    <Row justify="center" align="middle" style={{ paddingBottom: 30 }}>
                        <Col span={4}></Col>
                        <Col span={16}>
                            <p>Please Submit the YouTube Video URL to get the results</p>
                            <Row justify="center" align="middle">
                                <Col justify="center" span={20}><Input placeholder='https://www.youtube.com/watch?v=mls8tiiI3uc' defaultValue="Enter a Video URL" value={query} onChange={event => setQuery(event.target.value)} /></Col>
                                <Col justify="center" span={4}><Button type="primary" onClick={() => button_click_handler()}>Submit</Button></Col>
                            </Row>
                        </Col>
                        <Col span={4}></Col>
                    </Row>

                    {/* Loader Component */}
                    <div className="container" style={{ display: isLoading ? "flex" : "none" }} >
                        <LoaderComponent />
                    </div>

                    {/* Error Component */}
                    <div className="container" style={{ display: (!isLoading && !show) ? "flex" : "none" }}>
                        <h5>{commentData.message}</h5>
                    </div>

                    {/* YouTube Video Embed Component */}
                    <YoutubeEmbed show={show} isLoading={isLoading} embedId={search} />

                    {/* PieChart Component */}
                    <PieChart show={show} isLoading={isLoading} commentData={commentData.data} />

                    {/* Wordcloud Component */}
                    <WordCloud show={show} isLoading={isLoading} words={words} />

                    {/* CommentBox Component */}
                    <CommentBox show={show} isLoading={isLoading} commentData={commentData.data} />

                </Col>

                {/* Padding */}
                <Col xs={{ span: 2 }} lg={{ span: 4 }}>
                </Col>

            </Row>
        </React.Fragment>
    );
};

export default CommentTemp;